import React from 'react';
import { Box } from '@mui/system';
import NavbarAutoComplete from '../Home/Navbar/NavbarAutoComplete';
import { Typography } from '@mui/material';
import { Helmet } from 'react-helmet';

const PersonInfoQuestion = ({ newLocation, setNewLocation, newPreferedInsurance, setNewPreferedInsurance, newPreferedSpecialty, setNewPreferedSpecialty }) => {

    return (
        <>
            <Helmet>
                <title>Caralyst | Physician Preferences</title>
                <meta
                    name="description"
                    content="Provide your preferences including location, specialty, and insurance to find the right physician for you."
                />
                <meta
                    property="og:title"
                    content="Caralyst | Provide Your Physician Preferences"
                />
                <meta
                    property="og:description"
                    content="Choose your location, specialty, and insurance preferences to find the perfect physician match."
                />
                <meta property="og:url" content="https://my.caralyst.io/onboard/questionnaire/0" />
                <link rel="icon" type="image/x-icon" href="/icon_dark.png" />
            </Helmet>
            <Box aria-label="person-info-wrapper"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: '2rem',
                }}
            >
                <Typography variant='h5' sx={{ marginBottom: '1rem', textAlign: 'center', padding: "0.5rem" }}>
                    Please provide some information so we know which physicians fit within your preferences.
                </Typography>
                <NavbarAutoComplete variant='quiz' type='location' location={newLocation} setLocation={setNewLocation} />
                <NavbarAutoComplete variant='quiz' type='specialty' preferedSpecialty={newPreferedSpecialty} setSpecialtyPreference={setNewPreferedSpecialty} />
                <NavbarAutoComplete variant='quiz' type='insurance' preferedInsurance={newPreferedInsurance} setInsurancePreference={setNewPreferedInsurance} />
            </Box>
        </>
    );
}

export default PersonInfoQuestion;